// import Vue from 'vue';
import router from '../router';
import HTTP from '../http';

export default {
  namespaced: true,
  state: {
    isFetchingProperties: true,
    properties: [],
    property: {},
    imagesToUpload: [],
    dataManagement: false,
    showInvisibleProperties: false,
    slideShowCount: 0,
  },
  actions: {
    fetchProperties({ commit }) {
      this.isFetchingProperties = true;
      return HTTP().get('/properties')
        .then(({ data }) => {
          commit('setProperties', data);
        });
    },
    saveImages({ commit, state }) {
      const formData = new FormData();
      for (let index = 0; index < state.imagesToUpload.length; index += 1) {
        formData.append('images', state.imagesToUpload[index], 'imagem.jpg');
      }
      formData.append('property_id', state.property.id);
      formData.append('viewOrderFirst', state.imagesToUpload.length);

      return HTTP().post('/image', formData)
        .then(({ data }) => {
          commit('setImages', data);
        });
      // .catch((error) => {
      //   console.log(error);
      // });
    },
    deleteImage({ commit }, { propertyId, imageId }) {
      return HTTP().delete(`/image/${imageId}`)
        .then(() => {
          commit('setDeleteImage', { propertyId, imageId });
        });
      // .catch((error) => {
      //   console.log(error);
      // });
    },
    sortImages({ commit, state }) {
      const imagesTmp = [];
      for (let index = 0; index < state.property.images.length; index += 1) {
        imagesTmp.push({ ...state.property.images[index] });
      }
      imagesTmp.map((image, index) => {
        const imageTmp = image;
        imageTmp.viewOrder = index;
        delete imageTmp.image;
        return imageTmp;
      });
      return HTTP().patch('/image', { images: imagesTmp, property_id: state.property.id })
        .then(({ data }) => {
          commit('setImagesSorted', data);
        });
    },
    saveProperty({ commit, state }) {
      const propertyTmp = { ...state.property, ...state.property.restrict };
      delete propertyTmp.images;
      delete propertyTmp.restrict;
      return HTTP().patch(`/properties/${propertyTmp.id}`, propertyTmp)
        .then(({ data }) => {
          commit('setPropertyUpdated', data);
        });
    },
    createProperty({ commit, state }, { callback }) {
      return HTTP().post('/properties', state.property)
        .then(({ data }) => {
          commit('setPropertyCreated', data);
          callback();
        });
    },
  },
  getters: {
  },
  mutations: {
    setProperties(state, properties) {
      state.properties = properties.data;
      state.isFetchingProperties = false;
    },
    setSlideShowCount(state, count) {
      state.slideShowCount = count;
    },
    setProperty(state, property) {
      state.property = property;
    },
    setPropertyUpdated(state, propertyUpdated) {
      state.properties[
        state.properties.findIndex((property) => {
          return property.id === propertyUpdated.id;
        })
      ] = propertyUpdated;
    },
    setPropertyCreated(state, propertyCreated) {
      state.properties.push(propertyCreated);
      router.push(`/property/${propertyCreated.id}`);
    },
    setImagesToUpload(state, images) {
      state.imagesToUpload = images;
    },
    setImages(state, images) {
      state.properties.filter((property) => {
        return property.id === parseInt(state.property.id, 10);
      })[0].images.push(...images.successes);
    },
    setImagesSorted(state, data) {
      const propertyIndex = state.properties.findIndex((property) => {
        return property.id === state.property.id;
      });
      state.properties[propertyIndex] = data;
    },
    setDeleteImage(state, { propertyId, imageId }) {
      const imageIndex = state.properties.filter((property) => {
        return property.id === propertyId;
      })[0].images.findIndex((image) => {
        return image.id === imageId;
      });
      state.properties.filter((property) => {
        return property.id === propertyId;
      })[0].images.splice(imageIndex, 1);
    },
    setDataManagement(state, value) {
      state.dataManagement = value;
      if (!value) {
        state.showInvisibleProperties = value;
      }
    },
    setShowInvisible(state, value) {
      state.showInvisibleProperties = value;
    },
  },
};
